import React from 'react';
import { TrophyIcon } from 'lucide-react';
interface SportSelectionStepProps {
  selectedSports: string[];
  onSelectSport: (sport: string) => void;
  onNextStep: () => void;
  onPrevStep: () => void;
}
export const SportSelectionStep = ({
  selectedSports,
  onSelectSport,
  onNextStep,
  onPrevStep
}: SportSelectionStepProps) => {
  const sports = [{
    name: 'NBA',
    emoji: '🏀'
  }, {
    name: 'NFL',
    emoji: '🏈'
  }, {
    name: 'MLB',
    emoji: '⚾'
  }, {
    name: 'NHL',
    emoji: '🏒'
  }, {
    name: 'Soccer',
    emoji: '⚽'
  }, {
    name: 'Tennis',
    emoji: '🎾'
  }, {
    name: 'Golf',
    emoji: '🏌️'
  }, {
    name: 'UFC',
    emoji: '🥊'
  }, {
    name: 'Formula One',
    emoji: '🏎️'
  }];
  return <div data-id="element-493">
      <h1 className="text-3xl font-bold mb-4" data-id="element-494">Select Your Favorite Sports</h1>
      <p className="text-xl mb-6" data-id="element-495">
        Choose the sports you're interested in following.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8" data-id="element-496">
        {sports.map(sport => <button key={sport.name} onClick={() => onSelectSport(sport.name)} className={`p-4 rounded-lg border-2 flex items-center justify-center ${selectedSports.includes(sport.name) ? 'border-sky-500 bg-sky-50' : 'border-gray-300'}`} data-id="element-497">
            <TrophyIcon className={`mr-2 ${selectedSports.includes(sport.name) ? 'text-sky-500' : 'text-gray-500'}`} size={20} data-id="element-498" />
            <span className={selectedSports.includes(sport.name) ? 'text-sky-700 font-medium' : ''} data-id="element-499">
              {sport.emoji} {sport.name}
            </span>
          </button>)}
      </div>
      <div className="flex justify-between mt-8" data-id="element-500">
        <button onClick={onPrevStep} className="border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-medium hover:bg-gray-50 transition-colors" data-id="element-501">
          Back
        </button>
        <button onClick={onNextStep} className="bg-gradient-to-r from-sky-500 to-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:from-sky-600 hover:to-blue-700 transition-colors" disabled={selectedSports.length === 0} data-id="element-502">
          Continue
        </button>
      </div>
    </div>;
};